// src/Lexprompt/components/CollaborationSidebar.jsx

import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../user/AuthContext";

import {
  db,
  collection,
  addDoc,
  onSnapshot,
  query,
  where,
  doc,
} from "../firebaseConfig";

// Import updateDoc directly from firebase/firestore
import { updateDoc } from "firebase/firestore";

import "../pages/CollaborationSidebar.css";

export default function CollaborationSidebar({ promptId }) {
  const currentUser = useContext(AuthContext);
  const [collaborators, setCollaborators] = useState([]);
  const [newEmail, setNewEmail] = useState("");

  useEffect(() => {
    if (!promptId) return;

    const collabRef = collection(db, "prompts", promptId, "collaborators");
    const q = query(collabRef, where("status", "==", "active"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const loaded = [];
      snapshot.forEach((docSnap) => {
        loaded.push({ id: docSnap.id, ...docSnap.data() });
      });
      setCollaborators(loaded);
    });

    return () => unsubscribe();
  }, [promptId]);

  const handleInvite = async () => {
    if (!currentUser) {
      alert("Please log in to invite collaborators.");
      return;
    }
    if (!newEmail.trim()) return;

    const collabRef = collection(db, "prompts", promptId, "collaborators");
    try {
      await addDoc(collabRef, {
        email: newEmail.trim(),
        status: "pending",
        invitedAt: new Date(),
      });
      setNewEmail("");
    } catch (err) {
      console.error("Error inviting collaborator:", err);
      alert("Failed to invite. Please try again.");
    }
  };

  const handleAccept = async (collabDocId) => {
    try {
      const docRef = doc(db, "prompts", promptId, "collaborators", collabDocId);
      await updateDoc(docRef, { status: "active" });
    } catch (err) {
      console.error("Error accepting collaborator:", err);
    }
  };

  return (
    <div className="collab-sidebar">
      <h3>Collaborators</h3>
      <ul className="collab-list">
        {collaborators.map((c) => (
          <li key={c.id} className="collab-item">
            <span>{c.email}</span>
            {c.status === "pending" && (
              <button
                className="btn-secondary-sm"
                onClick={() => handleAccept(c.id)}
              >
                Accept
              </button>
            )}
          </li>
        ))}
        {collaborators.length === 0 && <p>No collaborators yet.</p>}
      </ul>

      <div className="invite-section">
        <input
          type="email"
          className="invite-input"
          placeholder="Enter email"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
        />
        <button className="btn-primary-sm" onClick={handleInvite}>
          Invite
        </button>
      </div>
    </div>
  );
}
